import { render, staticRenderFns } from "./CampaignDashboard.vue?vue&type=template&id=df857842"
import script from "./CampaignDashboard.vue?vue&type=script&lang=js"
export * from "./CampaignDashboard.vue?vue&type=script&lang=js"
import style0 from "./CampaignDashboard.vue?vue&type=style&index=0&id=df857842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports